// Reference-counted body scroll lock so independent overlays (nav menu,
// speed dial, ...) can lock/unlock without one closing early and undoing
// the lock still held by another.
//
// No scrollbar-width compensation is needed here: `scrollbar-gutter: stable`
// on `html` (src/scss/_base.scss) keeps the viewport width constant whether
// or not the scrollbar is actually showing, so toggling `overflow: hidden`
// never shifts layout in the first place.
let lockCount = 0;

export function lockScroll(): void {
  if (lockCount === 0) {
    document.body.style.overflow = 'hidden';
  }
  lockCount++;
}

export function unlockScroll(): void {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0) {
    document.body.style.overflow = '';
  }
}
